import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

import { Issue } from '@app/models/issue';
import { BrandService } from '@app/services/brand.service';
import { ModalService } from '@app/services/modal.service';
import { DisconnectButtonComponent } from '@app/shared/disconnect-button/disconnect-button.component';
import { MainStatusbarComponent } from '@app/shared/main-statusbar/main-statusbar.component';
import { ReleaseInfoComponent } from '@app/shared/release-info/release-info.component';
import { SaveProblemReportButtonComponent } from '@app/shared/save-problem-report-button/save-problem-report-button.component';
import { SwitchBackButtonComponent } from '@app/shared/switch-back-button/switch-back-button.component';
import { UpdateSoftwareButtonComponent } from '@app/shared/update-software-button.component';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  imports: [
    RouterLink,
    SwitchBackButtonComponent,
    UpdateSoftwareButtonComponent,
    SaveProblemReportButtonComponent,
    DisconnectButtonComponent,
    ReleaseInfoComponent,
    MainStatusbarComponent,
    AsyncPipe,
  ],
})
export class IssueComponent implements OnInit, OnDestroy {
  private brandService = inject(BrandService);
  private route = inject(ActivatedRoute);
  private modalService = inject(ModalService);

  logoUrl$ = this.brandService.logoUrl$;
  brandName$ = this.brandService.brandName$;
  isOblacDrivesBrand$ = this.brandService.isOblacDrivesBrand$;

  issue: Issue;

  subscriptions = new Subscription();

  ngOnInit() {
    this.subscriptions.add(this.route.data.subscribe((data) => (this.issue = data.issue)));

    // dismiss all modals when navigating to the issue page
    // typically, this happens because devices are no longer available
    // and the user is redirected to /issues
    this.modalService.dismissAll('navigated to the issue page');
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
